export const Clients = [
  {
    id: 1,
    name: "Publicis Media Schweiz AG",
    img: "/companies/publicis.webp",
    url: "https://www.publicisgroupe.ch/",
  },
  {
    id: 2,
    name: "Mediadschungel GmbH",
    img: "/companies/md-logo.webp",
    url: "https://www.mediadschungel.ch/",
  },
  {
    id: 3,
    name: "INP Schweiz AG",
    img: "/companies/logo-inp.webp",
    url: "https://www.inp-e.ch/",
  },
  {
    id: 4,
    name: "Waldis Tresore AG",
    img: "/companies/waldis-tresore.webp",
    url: "https://www.tresore.ch/",
  },
  {
    id: 5,
    name: "KMP AG",
    img: "/companies/kmp.webp",
    url: "https://www.kmpag.ch/",
  },
  {
    id: 6,
    name: "Hornatelier Medart",
    img: "/companies/medart.webp",
    url: "https://www.medart.ch/",
  },
  {
    id: 7,
    name: "Vorderberg Zahnärzte",
    img: "/companies/vorderberg.webp",
    url: "https://www.vorderberg.ch/",
  },
  {
    id: 8,
    name: "Vinca Film GmbH",
    img: "/companies/vincafilm.webp",
    url: "https://www.vincafilm.ch/",
  },
  {
    id: 9,
    name: "Credit Suisse",
    img: "/companies/cs.webp",
    url: "https://www.credit-suisse.com/",
  },
  {
    id: 10,
    name: "Mebatech AG",
    img: "/companies/mebatech.webp",
    url: "https://www.mebatech.ch/",
  },
  {
    id: 11,
    name: "Notice Design",
    img: "/companies/notice.webp",
    url: "https://www.notice.design/",
  },
  {
    id: 12,
    name: "Wesley's Kitchen",
    img: "/companies/wesleys.webp",
    url: "https://www.wesleys-kitchen.ch/",
  },
  {
    id: 13,
    name: "Berner Fachhochschule",
    img: "/companies/bfh.webp",
    url: "https://www.bfh.ch/",
  },
  {
    id: 14,
    name: "Wetter Gruppe",
    img: "/companies/wetter-gruppe.webp",
    url: "https://www.wetter-ag.ch/",
  },
  {
    id: 15,
    name: "Humbel Schnaps",
    img: "/companies/humbel.webp",
    url: "https://www.humbel.ch/",
  },
  {
    id: 16,
    name: "Lehre GR",
    img: "/companies/lehregr.webp",
    url: "https://www.lehre-gr.ch/",
  },
  {
    id: 17,
    name: "RIPENERGY AG",
    img: "/companies/ripenergy.webp",
    url: "https://www.ripenergy.ch/",
  },
  {
    id: 18,
    name: "Gemeinde Regensdorf",
    img: "/companies/regensdorf.webp",
    url: "https://www.regensdorf.ch/",
  },
  {
    id: 19,
    name: "UBS",
    img: "/companies/ubs.webp",
    url: "https://www.ubs.com/",
  },
  {
    id: 20,
    name: "Fondarex SA",
    img: "/companies/fondarex.webp",
    url: "https://www.fondarex.com/",
  },
  {
    id: 21,
    name: "Tilt Production",
    img: "/companies/tilt.webp",
    url: "https://www.tiltproduction.com/",
  },
  {
    id: 22,
    name: "Nordportal Eventhalle Baden",
    img: "/companies/nordportal.webp",
    url: "https://www.nordportal.ch/",
  },
  {
    id: 23,
    name: "VEGA Film & Distribution AG",
    img: "/companies/vega.webp",
    url: "https://www.vegafilm.com/",
  },
  {
    id: 24,
    name: "ZKB",
    img: "/companies/zkb.webp",
    url: "https://www.zkb.ch/",
  },
  {
    id: 25,
    name: "ZURICH Versicherungen",
    img: "/companies/zurich.webp",
    url: "https://www.zurich.ch/",
  },
  {
    id: 26,
    name: "Rivella",
    img: "/companies/rivella.webp",
    url: "https://www.rivella.ch/",
  },
  {
    id: 27,
    name: "Columbia Sportswear",
    img: "/companies/columbia.webp",
    url: "https://www.columbiasportswear.ch/",
  },
  {
    id: 28,
    name: "Sunrise",
    img: "/companies/sunrise.webp",
    url: "https://www.sunrise.ch/",
  },
  {
    id: 29,
    name: "Universal Music",
    img: "/companies/universal.webp",
    url: "https://www.universal-music.ch/",
  },
  {
    id: 30,
    name: "Filmcoopi Zürich AG",
    img: "/companies/filmcoopi.webp",
    url: "https://www.filmcoopi.ch/",
  },
  {
    id: 31,
    name: "Novissa",
    img: "/companies/novissa.webp",
    url: "https://www.novissa.ch/",
  },
  {
    id: 32,
    name: "AZ Immo AG",
    img: "/companies/azimmo.webp",
    url: "https://www.azimmobilien.ch/",
  },
  {
    id: 33,
    name: "Basellandschaftliche Kantonalbank",
    img: "/companies/blkb.webp",
    url: "https://www.blkb.ch/",
  },
  {
    id: 34,
    name: "Basler Künstlergesellschaft",
    img: "/companies/bkg.webp",
    url: "https://www.baslerkunstgesellschaft.ch/",
  },
  {
    id: 35,
    name: "Bernhard Burkard GmbH",
    img: "/companies/bernhard-burkard.webp",
    url: "https://www.bernhard-burkard.com/",
  },
  {
    id: 36,
    name: "Bogen Design",
    img: "/companies/bogen.webp",
    url: "https://www.bogen.ch/",
  },
  {
    id: 37,
    name: "Brack Electronics AG",
    img: "/companies/brack.webp",
    url: "https://www.brack.ch/",
  },
  {
    id: 38,
    name: "Business Images AG",
    img: "/companies/bi.webp",
    url: "https://www.businessimages.ch/",
  },
  {
    id: 39,
    name: "CTEK AG",
    img: "/companies/ctek.webp",
    url: "https://www.ctek.ch/",
  },
  {
    id: 40,
    name: "Girod Gründisch",
    img: "/companies/girodgruendisch.webp",
    url: "https://www.girodgruendisch.ch/",
  },
  {
    id: 41,
    name: "Küng Metzler Treyer",
    img: "/companies/kmt.webp",
    url: "https://www.kmtbaden.ch/",
  },
  {
    id: 42,
    name: "Stadt Baden",
    img: "/companies/baden.webp",
    url: "https://www.baden.ch/",
  },
  {
    id: 43,
    name: "Oniko AG",
    img: "/companies/oniko.webp",
    url: "https://www.oniko.ch/",
  },
  {
    id: 44,
    name: "Solid Identities GmbH",
    img: "/companies/solid.webp",
    url: "https://www.solid-identities.ch/",
  },
  {
    id: 45,
    name: "Swiss Interactive AG",
    img: "/companies/siag.webp",
    url: "https://www.swissinteractive.ch/",
  },
  {
    id: 46,
    name: "Reform Design",
    img: "/companies/reform.webp",
    url: "https://www.reform.design/",
  },
];
